(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["petition-rewards-v2"] && !Shopify.designMode) return;
  try {
    class PetitionRewardsV2 extends HTMLElement {
    connectedCallback() {
      this.sectionRoot = this.closest('.shopify-section') || document;
      this.handleVariantUpdate = () => {
        requestAnimationFrame(() => {
          this.connectProgress();
          this.render();
        });
      };
      this.sectionRoot.addEventListener('variant:update', this.handleVariantUpdate);
      this.connectProgress();
      this.render();
    }

    disconnectedCallback() {
      this.progressObserver?.disconnect();
      this.sectionRoot?.removeEventListener('variant:update', this.handleVariantUpdate);
    }

    connectProgress() {
      this.progressObserver?.disconnect();
      this.progress =
        this.sectionRoot.querySelector('[data-preorder-progress]') ||
        document.querySelector('[data-preorder-progress]');
      this.fundedElement = this.progress?.querySelector('[data-funded-orders]');

      if (this.progress) {
        this.progressObserver = new MutationObserver(() => this.render());
        this.progressObserver.observe(this.progress, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    }

    resolveStatus(pledges, goal) {
      if (pledges < 30) return goal === 30 ? 'next' : 'locked';
      if (pledges < 100) {
        if (goal === 30) return 'current';
        return goal === 100 ? 'next' : 'locked';
      }
      if (pledges < 200) {
        if (goal === 30) return 'unlocked';
        return goal === 100 ? 'current' : 'next';
      }
      return goal === 200 ? 'current' : 'unlocked';
    }

    render() {
      const progressValue = Number(this.fundedElement?.textContent?.trim());
      const fallbackValue = Number(this.dataset.currentPledges || 0);
      const pledges = Number.isFinite(progressValue) ? progressValue : fallbackValue;
      const labels = {
        current: this.dataset.labelCurrent,
        next: this.dataset.labelNext,
        unlocked: this.dataset.labelUnlocked,
        locked: this.dataset.labelLocked,
      };

      this.dataset.currentPledges = String(pledges);

      this.querySelectorAll('[data-reward-card]').forEach((card) => {
        const goal = Number(card.dataset.rewardGoal);
        const status = this.resolveStatus(pledges, goal);

        card.classList.remove(
          'petition-rewards-v2__card--current',
          'petition-rewards-v2__card--next',
          'petition-rewards-v2__card--unlocked',
          'petition-rewards-v2__card--locked'
        );
        card.classList.add(`petition-rewards-v2__card--${status}`);

        const statusElement = card.querySelector('[data-reward-status]');
        if (statusElement) statusElement.textContent = labels[status];

        const lock = card.querySelector('[data-reward-lock]');
        if (lock) {
          const firstCard = card.dataset.firstCard === 'true';
          lock.hidden = firstCard || (status !== 'next' && status !== 'locked');
        }
      });
    }
  }

  if (!customElements.get('petition-rewards-v2')) {
    customElements.define('petition-rewards-v2', PetitionRewardsV2);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wmi-buy-more"] && !Shopify.designMode) return;
  try {
    class WmiBuyMore extends HTMLElement {
    section = null;
    details = null;

    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.details = this.closest('[data-testid="product-information-details"]');

      if (!this.section || !this.details) return;

      this.addEventListener('click', this.handleTierClick);
      this.section.addEventListener('variant:update', this.handleVariantUpdate);
      this.section.addEventListener('quantity-selector:update', this.handleQuantityUpdate);
      this.section.addEventListener('input', this.handleQuantityInput);
      this.section.addEventListener('change', this.handleQuantityInput);

      requestAnimationFrame(() => this.syncFromNativeQuantity());
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleTierClick);
      this.section?.removeEventListener('variant:update', this.handleVariantUpdate);
      this.section?.removeEventListener('quantity-selector:update', this.handleQuantityUpdate);
      this.section?.removeEventListener('input', this.handleQuantityInput);
      this.section?.removeEventListener('change', this.handleQuantityInput);
    }

    getQuantityInput() {
      return this.details?.querySelector('quantity-selector-component input[name="quantity"]') ?? null;
    }

    handleTierClick = (event) => {
      if (!(event.target instanceof Element)) return;

      const tier = event.target.closest('[data-wmi-quantity]');
      if (!(tier instanceof HTMLButtonElement) || !this.contains(tier)) return;

      const quantity = Number(tier.dataset.wmiQuantity);
      if (!Number.isFinite(quantity)) return;

      this.setNativeQuantity(quantity);
    };

    handleVariantUpdate = (event) => {
      const eventProductId = event.detail?.data?.productId;
      if (eventProductId && String(eventProductId) !== this.dataset.productId) return;

      const html = event.detail?.data?.html;
      if (!(html instanceof Document)) return;

      const blockId = CSS.escape(this.dataset.blockId ?? '');
      const nextBlock = html.querySelector('wmi-buy-more[data-block-id="' + blockId + '"]');
      if (!nextBlock) return;

      this.querySelectorAll('[data-wmi-tier-index]').forEach((tier) => {
        const tierIndex = tier.getAttribute('data-wmi-tier-index');
        const currentPrice = tier.querySelector('[data-wmi-tier-price]');
        const nextPrice = nextBlock.querySelector(
          '[data-wmi-tier-index="' + tierIndex + '"] [data-wmi-tier-price]'
        );

        if (currentPrice && nextPrice) {
          currentPrice.textContent = nextPrice.textContent;
        }
      });

      requestAnimationFrame(() => this.syncFromNativeQuantity());
    };

    handleQuantityUpdate = (event) => {
      const input = this.getQuantityInput();
      const selector = input?.closest('quantity-selector-component');
      if (!input || !selector || event.target !== selector) return;

      const quantity = Number(event.detail?.quantity ?? input.value);
      this.setActiveTier(quantity);
    };

    handleQuantityInput = (event) => {
      const input = this.getQuantityInput();
      if (!input || event.target !== input) return;

      this.setActiveTier(Number(input.value));
    };

    setNativeQuantity(quantity) {
      const input = this.getQuantityInput();
      if (!input || input.disabled) return;

      const nextQuantity = this.normalizeQuantity(quantity, input);
      if (nextQuantity === null) return;

      input.value = String(nextQuantity);

      const selector = input.closest('quantity-selector-component');
      if (typeof selector?.updateButtonStates === 'function') {
        selector.updateButtonStates();
      }

      selector?.dispatchEvent(
        new CustomEvent('quantity-selector:update', {
          bubbles: true,
          detail: { quantity: nextQuantity },
        })
      );

      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this.setActiveTier(nextQuantity);
    }

    normalizeQuantity(quantity, input) {
      const minimum = Number(input.min) || 1;
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      const step = Number(input.step) || 1;
      const highestValidQuantity = Number.isFinite(maximum)
        ? minimum + Math.floor((maximum - minimum) / step) * step
        : Number.POSITIVE_INFINITY;

      if (highestValidQuantity < minimum) return null;

      const requestedQuantity = Math.max(minimum, quantity);
      const steppedQuantity = minimum + Math.ceil((requestedQuantity - minimum) / step) * step;

      if (steppedQuantity > highestValidQuantity) return null;

      return steppedQuantity;
    }

    syncFromNativeQuantity() {
      const input = this.getQuantityInput();
      if (!input) return;

      this.updateTierAvailability(input);
      this.setActiveTier(Number(input.value));
    }

    updateTierAvailability(input) {
      this.querySelectorAll('[data-wmi-quantity]').forEach((tier) => {
        const quantity = Number(tier.getAttribute('data-wmi-quantity'));
        tier.disabled = this.normalizeQuantity(quantity, input) === null;
      });
    }

    setActiveTier(quantity) {
      if (!Number.isFinite(quantity)) return;

      const tiers = Array.from(this.querySelectorAll('[data-wmi-quantity]'))
        .map((tier) => ({ tier, quantity: Number(tier.getAttribute('data-wmi-quantity')) }))
        .filter(({ quantity: tierQuantity }) => Number.isFinite(tierQuantity))
        .sort((first, second) => first.quantity - second.quantity);

      if (tiers.length === 0) return;

      let activeTier = tiers[0].tier;
      tiers.forEach(({ tier, quantity: tierQuantity }) => {
        if (quantity >= tierQuantity) activeTier = tier;
      });

      tiers.forEach(({ tier }) => {
        const isSelected = tier === activeTier;
        tier.classList.toggle('is-selected', isSelected);
        tier.setAttribute('aria-pressed', String(isSelected));
      });
    }
  }

  if (!customElements.get('wmi-buy-more')) {
    customElements.define('wmi-buy-more', WmiBuyMore);
  }
  } catch(e) { console.error(e); }
})();

})();
